import { NgStyle } from '@angular/common';
import { Component, OnDestroy, OnInit, input, output } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideX } from '@ng-icons/lucide';
import { HlmIcon } from '../../../../ui/icon/src';
import { HlmInput } from '../../../../ui/input/src';
// import { Store } from '@ngrx/store';
import { Subject, Subscription, debounceTime, distinctUntilChanged, tap } from 'rxjs';

@Component({
  selector: 'app-text-search-filter[context]',
  template: `
    <div class="relative">
      <input 
        hlmInput 
        [formControl]="search" 
        placeholder="Search" 
        class="pr-8"
      />
      <ng-icon
        hlm
        name="lucideX"
        [ngStyle]="{ opacity: search.value ? 1 : 0 }"
        (click)="search.reset()"
        class="absolute right-2 top-1/2 -translate-y-1/2 cursor-pointer text-muted-foreground hover:text-foreground" />
    </div>
  `,
  styles: [],
  imports: [HlmInput, FormsModule, ReactiveFormsModule, NgIcon, HlmIcon, NgStyle],
  providers: [provideIcons({ lucideX })],
})
export class TextSearchFilterComponent implements OnInit, OnDestroy {
  readonly searchTextChange = output<string>();

  readonly context = input.required<'user' | 'archive'>();
  readonly reset = input<Subject<void>>();

  search = new UntypedFormControl('');

  subs: Subscription[] = [];

  ngOnInit(): void {
    // Initialize formControl value
    if (this.context() === 'user') {
      // this.store
      //   .select(selectUserFilterSearch)
      //   .pipe(take(1))
      //   .subscribe(({ value }) => this.search.setValue(value));
    }

    // on form control value change, update store
    this.subs.push(
      this.search.valueChanges
        .pipe(
          debounceTime(200),
          distinctUntilChanged(),
          tap(value => this.searchTextChange.emit(value))
        )
        .subscribe()
    );

    const reset = this.reset();
    if (reset) this.subs.push(reset.subscribe(() => this.search.reset()));
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub?.unsubscribe());
  }
}
